import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import {
  DashboardComponent,
  LoginComponent,
  CompanyComponent,
  MarketComponent,
  PageNotFoundComponent,
  PageErrorComponent,
  CourseLockedComponent,
  ConnectComponent,
  LogoutComponent,
  DocumentsComponent,
  TeamComponent,
} from "@/core/pages";

import { AuthGuard } from "@/shared-module/helpers";

const routes: Routes = [
  { path: "login", component: LoginComponent },
  { path: "logout", component: LogoutComponent },
  { path: "error", component: PageErrorComponent },
  { path: "courselocked", component: CourseLockedComponent },
  { path: "connect", component: ConnectComponent },

  {
    path: "cvclight/dashboard",
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cvclight/dashboard/:path",
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cvclight/company/:path/:subpath",
    component: CompanyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cvclight/company/:path",
    component: CompanyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cvclight/company",
    component: CompanyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cvclight/market/:path/:subpath",
    component: MarketComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cvclight/market/:path",
    component: MarketComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cvclight/market",
    component: MarketComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cvclight/documents",
    component: DocumentsComponent,
    canActivate: [AuthGuard],
  },
  { path: "cvclight/team", component: TeamComponent, canActivate: [AuthGuard] },

  {
    path: "cvcoriginal/dashboard",
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cvcoriginal/dashboard/:path",
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cvcoriginal/company/:path/:subpath",
    component: CompanyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cvcoriginal/company/:path",
    component: CompanyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cvcoriginal/company",
    component: CompanyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cvcoriginal/market/:path/:subpath",
    component: MarketComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cvcoriginal/market/:path",
    component: MarketComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cvcoriginal/market",
    component: MarketComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cvcoriginal/documents",
    component: DocumentsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cvcoriginal/team",
    component: TeamComponent,
    canActivate: [AuthGuard],
  },

  {
    path: "cvcevo/dashboard",
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cvcevo/dashboard/:path",
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cvcevo/company/:path/:subpath",
    component: CompanyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cvcevo/company/:path",
    component: CompanyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cvcevo/company",
    component: CompanyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cvcevo/market/:path/:subpath",
    component: MarketComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cvcevo/market/:path",
    component: MarketComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cvcevo/market",
    component: MarketComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cvcevo/documents",
    component: DocumentsComponent,
    canActivate: [AuthGuard],
  },
  { path: "cvcevo/team", component: TeamComponent, canActivate: [AuthGuard] },

  {
    path: "fof/dashboard",
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "fof/dashboard/:path",
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "fof/company/:path/:subpath",
    component: CompanyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "fof/company/:path",
    component: CompanyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "fof/company",
    component: CompanyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "fof/market/:path/:subpath",
    component: MarketComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "fof/market/:path",
    component: MarketComponent,
    canActivate: [AuthGuard],
  },
  { path: "fof/market", component: MarketComponent, canActivate: [AuthGuard] },
  {
    path: "fof/documents",
    component: DocumentsComponent,
    canActivate: [AuthGuard],
  },
  { path: "fof/team", component: TeamComponent, canActivate: [AuthGuard] },

  {
    path: "tca/dashboard",
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "tca/dashboard/:path",
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "tca/company/:path/:subpath",
    component: CompanyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "tca/company/:path",
    component: CompanyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "tca/company",
    component: CompanyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "tca/market/:path/:subpath",
    component: MarketComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "tca/market/:path",
    component: MarketComponent,
    canActivate: [AuthGuard],
  },
  { path: "tca/market", component: MarketComponent, canActivate: [AuthGuard] },
  {
    path: "tca/documents",
    component: DocumentsComponent,
    canActivate: [AuthGuard],
  },
  { path: "tca/team", component: TeamComponent, canActivate: [AuthGuard] },
  {
    path: "hcc/dashboard",
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "hcc/dashboard/:path",
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "hcc/company/:path/:subpath",
    component: CompanyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "hcc/company/:path",
    component: CompanyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "hcc/company",
    component: CompanyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "hcc/market/:path/:subpath",
    component: MarketComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "hcc/market/:path",
    component: MarketComponent,
    canActivate: [AuthGuard],
  },
  { path: "hcc/market", component: MarketComponent, canActivate: [AuthGuard] },
  {
    path: "hcc/documents",
    component: DocumentsComponent,
    canActivate: [AuthGuard],
  },
  { path: "hcc/team", component: TeamComponent, canActivate: [AuthGuard] },



  {
    path: "sustainability/dashboard",
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "sustainability/dashboard/:path",
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "sustainability/company/:path/:subpath",
    component: CompanyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "sustainability/company/:path",
    component: CompanyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "sustainability/company",
    component: CompanyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "sustainability/market/:path/:subpath",
    component: MarketComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "sustainability/market/:path",
    component: MarketComponent,
    canActivate: [AuthGuard],
  },
  { path: "sustainability/market", component: MarketComponent, canActivate: [AuthGuard] },
  {
    path: "sustainability/documents",
    component: DocumentsComponent,
    canActivate: [AuthGuard],
  },
  { path: "sustainability/team", component: TeamComponent, canActivate: [AuthGuard] },



  {
    path: "cvcoriginal",
    loadChildren: () =>
      import("./cvc-original-module/cvc-original-module.module").then(
        (m) => m.CvcOriginalModuleModule,
      ),
  },
  {
    path: "cvcevo",
    loadChildren: () =>
      import("./cvcevo-module/cvcevo-module.module").then(
        (m) => m.CvcEvoModuleModule,
      ),
  },
  {
    path: "cvclight",
    loadChildren: () =>
      import("./cvc-light-module/cvc-light-module.module").then(
        (m) => m.CvcLightModuleModule,
      ),
  },
  {
    path: "fof",
    loadChildren: () =>
      import("./fof-module/fof-module.module").then((m) => m.FofModuleModule),
  },
  {
    path: "tca",
    loadChildren: () =>
      import("./tca-module/tca-module.module").then((m) => m.TcaModuleModule),
  },
  {
    path: "hcc",
    loadChildren: () =>
      import("./hcc-module/hcc-module.module").then((m) => m.HccModuleModule),
  },
  {
    path: "sustainability",
    loadChildren: () =>
      import("./sustainability-module/sustainability-module.module").then((m) => m.SustainabilityModuleModule),
  },
  // otherwise redirect to home
  {
    path: "",
    redirectTo: "login",
    pathMatch: "full",
  },
  { path: "**", component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: "legacy" })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
